import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, Copy, RefreshCw } from 'lucide-react';
import { frDate } from '@/utils/currencyUtils';

/**
 * Bandeau d'une annonce expirée (2026-10-28), en tête de la page du colis ou du trajet : sa date est passée, elle n'est
 * plus visible ni ouverte aux propositions. Pour son auteur : « Republier avec une nouvelle date » (même annonce,
 * formulaire à date vide, retour en validation) et « Dupliquer » (nouvelle annonce, `onDuplicate`).
 * `kind` : « colis » | « trajet ».
 */
export default function ExpiredListingNotice({ kind, date, editPath, isOwner, onDuplicate }) {
  const navigate = useNavigate();
  const title = kind === 'trajet' ? 'Trajet expiré' : 'Annonce expirée';
  const which = kind === 'trajet' ? 'Sa date de départ' : 'Sa date limite';
  return (
    <div className="detail-banner detail-banner--gray" data-testid="banner-expired">
      <div className="detail-banner-icon"><Clock size={20} aria-hidden="true" /></div>
      <div className="detail-banner-body">
        <div className="detail-banner-title">{title}</div>
        <div className="detail-banner-text">
          {which} du {frDate(date)} est passée : {kind === 'trajet' ? 'il' : 'elle'} n&apos;apparaît plus et ne reçoit plus
          de propositions.
        </div>
        {isOwner && (
          <div className="detail-banner-actions">
            <button type="button" className="mlc-btn mlc-btn--primary" onClick={() => navigate(editPath)} data-testid="btn-republish-date">
              <RefreshCw size={14} aria-hidden="true" /> Republier avec une nouvelle date
            </button>
            {onDuplicate && (
              <button type="button" className="mlc-btn mlc-btn--ghost" onClick={onDuplicate} data-testid="btn-duplicate">
                <Copy size={14} aria-hidden="true" /> Dupliquer
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
